import instance from "services/axiosServices";

/**
 * @function getGerarTemplateSolicitacao
 * @returns {Promise<any>} - retorna o arquivo com base64, url e contentType.
 */
export const getGerarTemplateSolicitacao = async (
  idSolicitacaoVisita: string
): Promise<any> => {
  const url = `/locais/admin/solicitacaoVisita/gerar-template-solicitacao/v1/${idSolicitacaoVisita}`;
  const response = await instance.get(url);
  return response?.data;
};
